import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
Vue.config.productionTip = false;

// import BMap from 'vue-baidu-map'
//
// Vue.use(BMap, {
//     // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
//     ak: 'mxavvlLEKopX2HP8NvLHyAg5eDlobFwL'
// });
// #00BFFF

//初始化css
import '@/assets/css/reset.css';

//配置 rem 进行移动端适配
import '@/util/rem.js';
import '@/util/weChatSize';

import Vant from 'vant';
import 'vant/lib/index.css';
import { Lazyload } from 'vant';
Vue.use(Lazyload,{
    loading:'https://www.shoudaole.cn/uploads/default/loading.gif'
});
Vue.use(Vant); 
import vueSignature from "vue-signature"
Vue.use(vueSignature);

import wx from "weixin-js-sdk";
Vue.prototype.$wx = wx;



router.beforeEach((to, from, next) => {
    next();
    // if (to.meta.requireAuth) {// 判断该路由是否需要登录权限
    //     if (Cookies.get('s_id') && Cookies.get('s_id') !== 'null' ) {
    //         next();
    //     }else {
    //         next({
    //             path: '/shopLogin',
    //             query: { redirect: to.fullPath }  // 将跳转的路由path作为参数，登录成功后跳转到该路由
    //         })
    //     }
    // } else {
    //     next();
    // }
});
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
